import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'black-teach-features-section',
  templateUrl: './teach-features-section.component.html',
  styleUrls: ['./teach-features-section.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class TeachFeaturesSectionComponent {}
